import { render, staticRenderFns } from "./LegPickerSheetDesktop.vue?vue&type=template&id=74dc8d94"
import script from "./LegPickerSheetDesktop.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegPickerSheetDesktop.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports